<template>
  <el-row>
    <el-col :span="24">
      <div class="box">
        <div class="top_head">
          <div class="img_box">
            <img v-if="flagType" :src="pageData.PictureUrl" alt />
            <video controls v-else :src="pageData.videoUrl"></video>
          </div>
          <div class="text_box">
            <p class="title">{{ pageData.Title }}</p>
            <p
              class="company"
              v-if="pageData.CompanyOrPersonName"
            >单位名称：{{ pageData.CompanyOrPersonName }}</p>
          </div>
        </div>
        <div class="center_body">
          <p>
            <span class="left">技术领域：</span>
            <!-- <span class="right">{{ pageData.TechFieldEnum }}</span> -->
            <span
              v-if="pageData.TechFieldEnum"
              class="right"
            >{{ this.$route.query.type == "3" ? pageData.TechFieldEnum.substring(0,pageData.TechFieldEnum.length-1) : this.$route.query.type == "4" ? pageData.TechFieldEnum.substring(0,pageData.TechFieldEnum.length-1) :this.$route.query.type == "1" ? pageData.TechFieldEnum : this.$route.query.type == "2" ? pageData.TechFieldEnum:pageData.TechFieldEnum}}</span>
          </p>
          <p>
            <span class="left">拟投资金额：</span>
            <!-- <span  v-if="pageData.InvestMoney" class="right">{{ pageData.InvestMoney=="0"?"面议": pageData.InvestMoney + "万元" }}</span> -->
            <span
              v-if="pageData.InvestInFunds==undefined"
              class="right"
            >{{ pageData.InvestMoney=="0"?"面议": pageData.InvestMoney + "万元" }}</span>
            <span
              v-else
              class="right"
            >{{ pageData.InvestInFunds=="0"?"面议": pageData.InvestInFunds + "万元" }}</span>
          </p>
          <p>
            <span class="left">合作方式：</span>
            <span class="right" v-if="pageData.ModeOfCooperation">
              {{
              pageData.ModeOfCooperation
              }}
            </span>
            <span class="right" v-else>{{ pageData.Coopera }}</span>
          </p>
        </div>
        <!-- 成果和需求厅 -->
        <div v-if="flagType" class="botm_foot">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane name="1">
              <template v-slot:label>
                <div :class="activeName == 1 ? 'isAV' : ''">项目简介</div>
              </template>
              <div
                class="textContainer"
                v-show="pageData.DetailsOfTheResults !== ''"
                v-html="pageData.DetailsOfTheResults"
              ></div>
              <div
                class="textContainer"
                v-show="pageData.DemandContent !== ''"
                v-html="pageData.Content"
              ></div>
              <div
                class="emptyContainer"
                v-show="
                  pageData.DetailsOfTheResults == '' || pageData.Content == ''
                "
              >
                <img src="../../assets/images/组 23588@2x.png" alt />
                <p>暂无内容</p>
              </div>
            </el-tab-pane>
            <el-tab-pane name="2">
              <template v-slot:label>
                <div :class="activeName == 2 ? 'isAV' : ''">项目图片</div>
              </template>
              <div class="run_img_box" v-if="pageData.imgsUrl !== ''">
                <img v-for="(item, index) in pageData.imgsUrl" :src="item" alt :key="index" />
              </div>
              <div class="emptyContainer" v-else>
                <img src="../../assets/images/组 23588@2x.png" alt />
                <p>暂无内容</p>
              </div>
            </el-tab-pane>
            <el-tab-pane name="3">
              <template v-slot:label>
                <div :class="activeName == 3 ? 'isAV' : ''">项目视频</div>
              </template>
              <div class="video_box" v-if="pageData.videoUrl">
                <video controls="controls" :src="pageData.videoUrl"></video>
              </div>
              <div class="emptyContainer" v-else>
                <img src="../../assets/images/组 23588@2x.png" alt />
                <p>暂无内容</p>
              </div>
            </el-tab-pane>
            <el-tab-pane name="4">
              <template v-slot:label>
                <div :class="activeName == 4 ? 'isAV' : ''">留言对接</div>
              </template>
              <div v-if="showLam" class="lam_box">
                <div class="lam" v-for="(item, index) in dockArr" :key="index">
                  <div class="all_box">
                    <div class="head_img_box">
                      <img src="../../assets/library/组 4218@2x.png" alt />
                    </div>
                    <div class="lam_text_box">
                      <div class="top">
                        <span class="name">{{ item.UserName }}</span>
                        <span class="time">{{ item.Create_time }}</span>
                      </div>
                      <p class="botm">{{ item.Content }}</p>
                    </div>
                  </div>
                  <el-divider></el-divider>
                </div>
              </div>
              <div class="emptyContainer" v-else>
                <img src="../../assets/images/组 23588@2x.png" alt />
                <p>暂无内容</p>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <!-- 云路演 -->

        <div v-else class="botm_foot">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane name="1">
              <template v-slot:label>
                <div :class="activeName == 1 ? 'isAV' : ''">项目简介</div>
              </template>
              <div
                class="textContainer"
                v-show="pageData.DetailsOfTheResults !== ''"
                v-html="pageData.DetailsOfTheResults"
              ></div>
              <div
                class="textContainer"
                v-show="pageData.DemandContent !== ''"
                v-html="pageData.Content"
              ></div>
              <div
                class="emptyContainer"
                v-show="
                  pageData.DetailsOfTheResults == '' || pageData.Content == ''
                "
              >
                <img src="../../assets/images/组 23588@2x.png" alt />
                <p>暂无内容</p>
              </div>
            </el-tab-pane>

            <el-tab-pane name="4">
              <template v-slot:label>
                <div :class="activeName == 2 ? 'isAV' : ''">对接动态</div>
              </template>
              <div v-if="showLam" class="lam_box">
                <div class="lam" v-for="(item, index) in dockArr" :key="index">
                  <div class="all_box">
                    <div class="head_img_box">
                      <img src="../../assets/library/组 4218@2x.png" alt />
                    </div>
                    <div class="lam_text_box">
                      <div class="top">
                        <span class="name">{{ item.UserName }}</span>
                        <span class="time">{{ item.Create_time }}</span>
                      </div>
                      <p class="botm">{{ item.Content }}</p>
                    </div>
                  </div>
                  <el-divider></el-divider>
                </div>
              </div>
              <div class="emptyContainer" v-else>
                <img src="../../assets/images/组 23588@2x.png" alt />
                <p>暂无内容</p>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { postAction, getAction } from '@/api/api.js'
import { cloudSelect, imgcommonUrl, dockingList } from '@/api/url.js'
import qs from 'qs'
import Empty from '../../components/empty'

export default {
  name: '',
  data() {
    return {
      pageData: {},
      activeName: '1',
      imgCommonUrl: '',
      dockArr: [],
      showLam: true,
      flagType: true,
    }
  },
  props: {},
  components: { Empty },
  mounted() {
    //// console.log(this.$route.query, "===========================================");
    this.getPageData()
    this.imgCommonUrl = imgcommonUrl
    // 字体大小自适应
    var fontbig = ((window.innerWidth / (375 / 16)) * 100).toFixed(0) / 100
    document.documentElement.style.fontSize = fontbig + 'px'
    window.onresize = function () {
      var fontbig = ((window.innerWidth / (375 / 16)) * 100).toFixed(0) / 100
      document.documentElement.style.fontSize = fontbig + 'px'
    }
  },
  methods: {
    getPageData() {
      let data = {}
      let url
      if (this.$route.query.type == '1') {
        data = {
          action: 'Get_AchievementsInfo',
          userid: localStorage.getItem('RealID') || '',
          id: this.$route.query.id,
          // id: 60473,
        }
        url = cloudSelect
      } else if (this.$route.query.type == '2') {
        data = {
          action: 'Get_DemandInfo',
          userid: localStorage.getItem('RealID') || '',
          id: this.$route.query.id,
          // id: 60473,
        }
        url = cloudSelect
      } else if (this.$route.query.type == '3') {
        data = {
          action: 'Get_RoadShowById',
          userid: localStorage.getItem('RealID') || '',
          id: this.$route.query.id,
          // id: 60473,
          type: 1,
        }
        url = dockingList
      } else if (this.$route.query.type == '4') {
        data = {
          action: 'Get_RoadShowById',
          userid: localStorage.getItem('RealID') || '',
          id: this.$route.query.id,
          // id: 60473,
          type: 2,
        }
        url = dockingList
      }
      //   let data = {
      //     action: "Get_AchievementsInfo",
      //     userid: localStorage.getItem("RealID") || "",
      //     // id: this.$route.query.id,
      //     id: 60473,
      //   };
      //   this.$route.query.type == "1" && "2" ? cloudSelect : dockingList,
      // //// console.log(
      //   this.$route.query.type == "1" && "2" ? cloudSelect : dockingList
      // );
      postAction(url, qs.stringify(data)).then((res) => {
        //// console.log(res, "_++_+_+_+_+_+_+_+");
        if (!res.imgsUrl == '') {
          res.imgsUrl = res.imgsUrl.split('|')
        }
        if (this.$route.query.type == '3' || this.$route.query.type == '4') {
          let str = ''
          if (res.TechFieldEnum.indexOf('5') !== -1) {
            str += '新一代信息技术,'
          }
          if (res.TechFieldEnum.indexOf('7') !== -1) {
            str += '高端装备制造,'
          }
          if (res.TechFieldEnum.indexOf('10') !== -1) {
            str += '新型材料,'
          }
          if (res.TechFieldEnum.indexOf('11') !== -1) {
            str += '新能源及新能源汽车,'
          }
          if (res.TechFieldEnum.indexOf('13') !== -1) {
            str += '现代农业,'
          }
          if (res.TechFieldEnum.indexOf('14') !== -1) {
            str += '食品工业,'
          }
          if (res.TechFieldEnum.indexOf('9') !== -1) {
            str += '生物医药及健康,'
          }
          if (res.TechFieldEnum.indexOf('8') !== -1) {
            str += '节能环保,'
          }
          if (res.TechFieldEnum.indexOf('15') !== -1) {
            str += '公共安全和应急处置,'
          }
          if (res.TechFieldEnum.indexOf('16') !== -1) {
            str += '其他,'
          }
          res.TechFieldEnum = str
          this.flagType = false
        } else {
          this.pageData = res
        }
        // //// console.log(res.imgsUrl);
        this.pageData = res
        //// console.log(this.pageData);
      })
    },
    handleClick() {
      if (this.activeName == '4') {
        //// console.log(this.$route.query.id)

        let data = {
          action: 'Get_TechFieldList',
          sort: 'DESC',
          uid: localStorage.getItem('RealID'),
          projId: this.$route.query.id,
        }
        postAction(dockingList, qs.stringify(data)).then((res) => {
          if (res.length > 0) {
            //// console.log(res);
            this.dockArr = res
          } else {
            //// console.log(111111111111111);
            this.dockArr = []
            this.showLam = false
            //// console.log(this.showLam, "============");
          }
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
video {
  object-fit: fill;
}
.textContainer {
  text-align: left;
  padding: 0 0.9375rem;
}
/deep/ .el-tabs__nav-wrap::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  /* height: 2px; */
  background-color: #e4e7ed;
  z-index: 1;
}
.box {
  width: 23.4375rem;
  display: flex;
  flex-direction: column;
  background: #f6f6f6;
}
.top_head {
  background-color: #fff;
  .img_box {
    width: 23.4375rem;
    height: 12.5rem;
    img {
      width: 100%;
      height: 100%;
      vertical-align: bottom;
    }
    video {
      width: 23.4375rem;
      height: 12.5rem;
    }
  }
  .text_box {
    padding: 0.9375rem;
    text-align: left;
    .title {
      font-size: 1.125rem;
      font-family: PingFang SC;
      font-weight: 500;
      color: #2a3457;
      opacity: 1;
      padding-bottom: 0.5rem;
    }
    .company {
      font-size: 0.75rem;
      font-family: PingFang SC;
      font-weight: 400;
      color: #9fa3b3;
      opacity: 1;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
.center_body {
  background-color: #fff;
  margin-top: 0.625rem;
  padding: 0 0.9375rem;
  p {
    display: flex;
    justify-content: flex-start;
    margin: 0.9375rem 0;
    text-align: left;
    .left {
      min-width: 4.875rem;
      font-size: 0.8125rem;
      font-family: PingFang SC;
      font-weight: 400;
      color: #9fa3b3;
      opacity: 1;
    }
    .right {
      margin-left: 0.5rem;
      font-size: 0.8125rem;
      font-family: PingFang SC;
      font-weight: 400;
      color: #686f88;
      opacity: 1;
    }
  }
}
.botm_foot {
  margin-top: 0.625rem;
}
/deep/ .el-tabs {
  width: 100%;
  background-color: #fff;
  .el-tabs__nav {
    width: 100%;
    display: flex;
    justify-content: space-around;
    .el-tabs__active-bar {
      display: none;
      //   width: 25px !important;
      //   height: 4px;
      //   background: #2769dc;
      //   opacity: 1;
      //   margin-left: 30px !important;
      //   border-radius: 2px;
    }
  }
  .el-tabs__nav-wrap::after {
    display: none;
  }
  .el-tabs__item {
    text-align: center;
    padding: 0;
  }
  //   .el-tabs__item::after {
  //     border-bottom: 2px solid #2769dc;
  //     border-radius: 2px;
  //   }
}
.isAV {
  position: relative;
  &::after {
    content: '';
    position: absolute;
    bottom: 0rem;
    left: 50%;
    transform: translateX(-50%);
    height: 0.125rem;
    width: 1.5625rem;
    background-color: #2769dc;
    display: block;
    text-align: center;
  }
}
.run_img_box {
  //   width: 100%;
  padding: 0.9375rem;
  img {
    width: 100%;
    vertical-align: bottom;
    margin-bottom: 0.625rem;
  }
}
.video_box {
  //   width: 100%;
  height: 10.8125rem;
  padding: 0.9375rem;
  video {
    width: 100%;
    height: 100%;
  }
}
.lam_box {
  .lam {
    padding: 0.9375rem 1.25rem;
    display: flex;
    flex-direction: column;
    .all_box {
      display: flex;
      justify-content: flex-start;

      .head_img_box {
        width: 2.75rem;
        height: 2.75rem;
        margin-right: 0.625rem;
        img {
          width: 100%;
          height: 100%;
          vertical-align: bottom;
        }
      }
      .lam_text_box {
        width: 18.1875rem;
        // padding-left: 0.625rem;
        .top {
          display: flex;
          justify-content: space-between;
          .name {
            font-size: 1rem;
            font-family: PingFang SC;
            font-weight: 500;
            color: #2a3457;
            opacity: 1;
          }
          .time {
            font-size: 0.75rem;
            font-family: PingFang SC;
            font-weight: 400;
            color: #9fa3b3;
            opacity: 1;
          }
        }
        p {
          font-size: 1rem;
          font-family: PingFang SC;
          font-weight: 400;
          color: #686f88;
          opacity: 1;
          text-align: left;
          margin-top: 0.3125rem;
        }
      }
    }
  }
}
.emptyContainer {
  margin: 10.625rem auto 0;
  font-size: 0.875rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #c4c8d6;
  opacity: 1;
}
.emptyContainer > img {
  width: 8.125rem;
  height: auto;
}
</style>